module.exports = "/images/share_door.png";